import React from "react";
import { connect } from "react-redux";
import language from "../../../language/index.js";
import { Table } from "../../Table/index.js";
import { getStorage } from "../../../utils/storage.js";
import toastMessage from "../../../utils/toastMessage.js";

import {
  fetchShippingInQueueData,
  cancelShipment,
} from "../../../utils/queries/request/shipping-queue.js";
import { Modal } from "../../Modal/index.js";
import Reception from "../../Reception/reception-tab/index.js";
import { Button } from "../../Button/index.js";
import { defineRole } from "../../../utils/handleAccessRoles.js";
import { ROLE_REQUEST } from "../../../constants/ROLES.js";

class TransferredProducts extends React.Component {
  state = {
    isLoading: false,
    data: [],
    selected_data: {},
    error: {},
    csvData: [],
    delete_password: "",
    user: {},
    page: 1,
    limit: 500,
    isCancelling: false,
  };

  // A dispatch can be called back while it is still travelling. Once any line
  // has been received the units are in someone else's stock, and only a return
  // can move them — the API refuses the cancel at that point too.
  canCancelTransfer() {
    const rows = this.state.data || [];

    if (!rows.length) return false;
    if (rows.some((el) => el.status === "received")) return false;

    return !!defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_REQUEST,
      operation: "update",
    });
  }

  handleCancelTransfer = async () => {
    this.setState({ isCancelling: true });

    await cancelShipment(this.props.defaultLanguage, this.props.shipmentNumber);

    this.setState({ isCancelling: false, showCancelModal: false });
    this.getData(true);
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  getData = async (isLoading) => {
    try {
      this.setState({ isLoading });
      const { shipmentNumber, requestNo, defaultLanguage } = this.props;

      const { data, count, totalRecords } = await fetchShippingInQueueData(defaultLanguage, {
        shipmentNumber,
        ...(requestNo && { requestNo }),
        page: this.state.page,
        limit: this.state.limit,
      });

      this.setState({ isLoading: false, data, totalPageCount: count });
    } catch (error) {
      this.setState({ isLoading: false });
      toastMessage("error", error);
    }
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation,
        key: "donation.donationNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "product",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "inventory.bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].source,
        key: "from.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].destination,
        key: "to.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      // {
      //   title: language[this.props.defaultLanguage].actions,
      //   key: "multiple-actions",
      //   actions: [
      //     {
      //       icon: icons.check,
      //       title: language[this.props.defaultLanguage].receive,
      //       onPress: (item) => console.log(item),
      //       className: "btn-primary",
      //     },
      //     {
      //       icon: icons.return,
      //       title: language[this.props.defaultLanguage].return,
      //       onPress: (item) => console.log(item),
      //       className: "btn-default",
      //     },
      //   ],
      // },
    ].filter(Boolean);

    return headers;
  }

  render() {
    return (
      <>
        {this.canCancelTransfer() && (
          <div className="d-flex justify-content-end mb-2">
            <Button
              text={language[this.props.defaultLanguage].cancel_transfer}
              className="btn-secondary"
              onPress={this.handleShowModal.bind(
                this,
                "showCancelModal",
                language[this.props.defaultLanguage].cancel_transfer
              )}
            />
          </div>
        )}
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          headers={this.returnTableHeaders()}
          showAdd
          addButtonText={language[this.props.defaultLanguage].reception}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].reception
          )}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <Reception
            shipmentNumber={this.props.shipmentNumber}
            getData={() => this.getData(true)}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showCancelModal")}
          show={this.state.showCancelModal}
          title={language[this.props.defaultLanguage].cancel_transfer}
          showHeaderBottomBorder={false}
        >
          <div className="card-body">
            <p>
              {language[this.props.defaultLanguage].cancel_transfer_description}
            </p>
            <div className="d-flex justify-content-end gap-2">
              <Button
                text={language[this.props.defaultLanguage].no}
                className="btn-default"
                onPress={this.handleCloseModal.bind(this, "showCancelModal")}
              />
              <Button
                text={language[this.props.defaultLanguage].yes}
                isSubmitting={this.state.isCancelling}
                onPress={this.handleCancelTransfer}
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(TransferredProducts);
